import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import type { PropsWithChildren } from 'react';
import type React from 'react';
import styled from 'styled-components';
import { TuneInfoComponentsFactory } from './infoComponents/TunesInfoFactory';
import type { TuneControlsDisclaimerType } from '@/engine/app/interfaces';
import { useTheme } from '@mui/material/styles';
import { useIdentifiersListTuner } from './useIdentifiersListTuner';

interface SelectTuneProps {
  descriptor: string;
  disclaimer?: TuneControlsDisclaimerType;
  label: string;
}

export const SelectTune: React.FC<PropsWithChildren<SelectTuneProps>> = (props) => {
  const theme = useTheme();

  const { value, valuesList, tuner } = useIdentifiersListTuner(props.descriptor);

  const selectStyles = {
    width: 200,
    marginRight: '0.2em',
    ...(theme.mode === 'dark'
      ? {
          '.MuiSvgIcon-root ': {
            fill: theme.font
          },
          border: `1px solid  ${theme.font}`,
          color: theme.font
        }
      : {})
  };

  const dropdownBox = (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <ControlContainer>
          <InputLabel id={props.descriptor + '-select-label'}>{props.label}</InputLabel>
          <Select
            sx={selectStyles}
            labelId={props.descriptor + '-select-label'}
            id={props.descriptor + '-select'}
            data-testid={props.descriptor + 'SelectTuneBtn'}
            value={value ?? '-'}
            disabled={value === undefined}
            label={props.label}
            onChange={(event): void => tuner.doTune(event.target.value)}
          >
            {(value === undefined ? ['-'] : valuesList).map((listItem: string, index: number) => {
              return (
                <MenuItem value={listItem} key={'menu-item' + index}>
                  {listItem}
                </MenuItem>
              );
            })}
          </Select>
          <TuneInfoComponentsFactory disclaimer={props.disclaimer} />
        </ControlContainer>
      </FormControl>
    </Box>
  );

  return valuesList.length > 1 ? dropdownBox : null;
};

const ControlContainer = styled.div`
  padding: 0 0 0.6em 0;
  position: relative;
  margin-top: 0.6em;
`;
